export default function Badge({ children, variant = 'primary', className = '' }) {
    const variantClasses = {
        primary: 'badge-primary',
        success: 'badge-success',
        warning: 'badge-warning',
        danger: 'badge-danger',
        info: 'badge-info',
        reporter: 'badge-reporter',
        purple: 'badge-purple',
    };

    return (
        <span className={`badge ${variantClasses[variant] || 'badge-primary'} ${className}`}>
            {children}
        </span>
    );
}

